<template>
  <div>
    <div class="home-head">
      <img class="home-logo" src="https://m.voozaa.app/content/logo.png" alt="" />
      <span class="lang" @click="showLangSelect">{{ locale && locale.label }}</span>
    </div>
    <div class="home-body">
      <!-- <div v-if="!user" class="title">{{ i18n.powerbanktitle }}</div>
      <div v-if="!user" class="rentbtn" @click="loginOptionShow = true">{{ i18n.start }}</div>
      <button class="loginbtn" @click="goOrder" v-else>
        <img
          :src="loginMode === 'Google' ? require('../../assets/imgs/icon_googlepay.png') : loginMode === 'Apple' ? require('../../assets/imgs/icon_applepay.png') : loginMode === 'Facebook' ? require('../../assets/imgs/icon_facebook_unselected.png') : require('../../assets/imgs/icon_phone_selected.png')"
          alt="">
        <span>{{ user && user.pname }}</span>
      </button>
      <div class="logoutoptions" v-if="user" @click="onLogout">{{ i18n.logout }}</div> -->
      <div class="normaltitle">{{ i18n.selectmethod }}</div>
      <div v-if="payModeList.length > 0" class="paymethod">
        <template v-for="item in payModeList">
          <div class="paymethod-item" :class="{ 'select': payMode && payMode.label === item.label }"
            v-if="(item.phone === 'all' || item.phone === system || item.phone === browser || (item.phone === 'phone' && system !== ''))"
            :key="item.pId" @click="onPayMode(item)">
            <img v-if="item.label === 'Google Pay'"
              :src="require('../../assets/imgs/icon_googlepay.png')" alt="">
            <img v-else-if="item.label === 'Apple Pay'"
              :src="require('../../assets/imgs/icon_applepay.png')" alt="">
            <span v-else-if="item.label === 'Paypal'"></span>
            <img v-else :src="require('../../assets/imgs/icon_card_Unselected.png')" alt="">
            <span>{{ item.label }}</span>
          </div>
        </template>
      </div>
      <div v-else-if="!user || !cabinet" class="paymethod">
        <div class="paymethod-item" :class="{ 'select': payMode && payMode.pPaymentType === 'STRIPE_CARD' }"
          @click="payMode = { pPaymentType: 'STRIPE_CARD' }">
          <img src="../../assets/imgs/icon_card_Unselected.png" alt="">
          <span>Credit Card</span>
        </div>
        <div class="paymethod-item" @click="payMode = { pPaymentType: 'STRIPE_GOOGLE' }">
          <!-- <img src="../../assets/imgs/icon_googlepay.png" alt=""> -->
          <span>paypal</span>
        </div>
      </div>
      <div class="normaltitle">{{ i18n.paymentdetail }}</div>
      <div class="paymethod-detail">
        <div class="placeinput">
          <img class="preicon" src="../../assets/imgs/icon_pay.png" alt="">
          <input type="text" readonly :placeholder="placeholder">
          <img class="afticon" src="../../assets/imgs/icon_detail_green.png" alt="" @click="preAuthorShow = true">
        </div>
        <!-- <div v-if="(payMode && payMode.pPaymentType === 'STRIPE_CARD' && !token) || !cabinet" class="placeinput mt-4">
          <img class="preicon" src="../../assets/imgs/icon_card_Unselected.png" alt="">
          <input type="text" v-model="cardNum" placeholder="Card number">
          <span class="cvc">MM / YY CVC</span>
        </div>
        <div v-if="payMode && payMode.pPaymentType === 'STRIPE_CARD' && token && cabinet" class="placeinput mt-4">
          <div class="w-full" id="credit-card-element"></div>
        </div> -->
      </div>
      <div class="shopdetail">
        <img src="https://m.voozaa.app/content/introduction1.png" alt="">
        <div v-if="cabinet" class="centermsg">
          <p class="top">{{ currency }} {{ cabinet && cabinet.jifei && cabinet.jifei.toFixed(2) }} per {{ cabinet &&
        cabinet.jifeiDanwei }} minute</p>
          <p class="bottom">{{ currency }} {{ cabinet.fengding }} max. per day</p>
        </div>
        <div v-else class="centermsg">
          <p class="top">{{ currency }} 1 per 30 minute</p>
          <p class="bottom">{{ currency }} 5 max. per day</p>
        </div>
        <!-- <div class="pricing" @click="showRentCostPop">{{ i18n.pricing }} <img
            src="../../assets/imgs/icon_morearrow.png">
        </div> -->
      </div>
      <!-- <div class="normaltitle">{{ i18n.couponcode }}</div> -->
      <!-- <div class="coupon-code">
        <div class="placeinput">
          <img class="preicon" src="../../assets/imgs/icon_couponcode.png" alt="">
          <input type="text" v-model="couponCode" placeholder="Enter promo code">
        </div>
      </div> -->
      <div class="rentbtn" @click="onRent">{{ i18n.rent }}</div>
      <div class="agreen">
        {{ i18n.tips }}
        <a @click="viewAgreen('https://m.voozaa.app/content/privacy_policy.html')">{{ i18n.privacy }}</a>
        {{ i18n.and }}
        <a @click="viewAgreen('https://m.voozaa.app/content/user_agreement.html')">{{ i18n.term }}</a>
      </div>
    </div>
    <div v-if="loginOptionShow" class="mask" @click="loginOptionShow = false">
      <div class="mask-main" @click.stop>
        <div class="appleline"></div>
        <!-- <div class="loginoptions">
          <div class="loginoptions-item" :class="{ 'select': currentLoginMode === 'phone' }" @click="currentLoginMode = 'phone'">
            <img src="../../assets/imgs/icon_phone_selected.png" alt="">
            <span>{{ i18n.phone }}</span>
          </div>
          <div class="loginoptions-item" :class="{ 'select': currentLoginMode === 'Community' }" @click="currentLoginMode = 'Community'">
            <span>{{ i18n.otheropt }}</span>
          </div>
        </div> -->
        <div class="phonelogin">
          <div class="area" @click="isAreaView = true">
            <span>+{{ areaCode }}</span>
            <div class="area-down"></div>
          </div>
          <input type="number" v-model="phone" :placeholder="i18n.phonenumber">
          <img src="../../assets/imgs/icon_next_circle.png" alt="" @click="onSendCode">
        </div>
        <!-- <div class="phonelogin">
          <input type="number" v-model="code" :placeholder="i18n.captcha_code">
          <img class="captcha" :src="captchaUrl" alt="" @click="onCaptcha">
        </div> -->
        <!-- <LoginFacebook @success="loadUser(true)">
          <div class="facebookbtn">
            <img src="../../assets/imgs/icon_facebook.png" alt="">
            <span>{{ i18n.loginfb }}</span>
          </div>
        </LoginFacebook> -->
        <LoginGoogle @success="loadUser(true)" class="mb-8 minheight-5">
          <div class="buttonDiv" id="buttonDiv"></div>
          <div class="googlewarp">
            <img src="../../assets/imgs/icon_google.png" alt="">
            <span>{{ i18n.logingg }}</span>
          </div>
          <!-- <button class="goolebtn">
            <img src="../../assets/imgs/icon_google.png" alt="">
            <span>{{ i18n.Google }}</span>
          </button> -->
        </LoginGoogle>
        <div class="agreen">
          {{ i18n.tips }}
          <a @click="viewAgreen('https://m.voozaa.app/content/privacy_policy.html')">{{ i18n.privacy }}</a>
          {{ i18n.and }}
          <a @click="viewAgreen('https://m.voozaa.app/content/user_agreement.html')">{{ i18n.term }}</a>
        </div>
      </div>
    </div>
    <popup-warp v-model="isCreditcard">
      <div>
        <div class="creditcard-input">
          <div id="credit-card-element"></div>
        </div>
        <div class="btn creditcard-btn" @click="onStripeSetup">{{ i18nConfirm.title }}</div>
      </div>
    </popup-warp>
    <select-area v-model="isAreaView" @select="onSelct"></select-area>
    <PreAuthorTip v-if="preAuthorShow" @close="(res) => preAuthorShow = res"></PreAuthorTip>
    <RentCostTip v-if="rentCostShow" :jifei="cabinet && cabinet.jifei || 1"
      :jifeiDanwei="cabinet && cabinet.jifeiDanwei || 30" :fengding="cabinet && cabinet.fengding || 5"
      :yajin="cabinet && cabinet.yajin || 55" :cyajin="cabinet && cabinet.yajin || 1" :currency="currency"
      :currencyName="currencyName" @close="(res) => rentCostShow = res"></RentCostTip>
    <LoginCode v-if="loginCodeShow" @close="(res) => loginCodeShow = res" @submit="onLogin"></LoginCode>
  </div>
</template>

<script>
import md5 from 'js-md5'
import { mapState, mapGetters } from 'vuex'
import { getToken } from '../../utils/stripe_pay.js'
import stripeMixin from '../../mixins/stripe'
import { generateUUID } from '../../utils/index'
import { baseURL } from '../../utils/http'
import { SelectArea } from '../../components/select'
import PreAuthorTip from './component/preauthortip.vue'
import RentCostTip from './component/rentcosttip.vue'
import LoginCode from './component/logincode.vue'
import { LoginGoogle } from '../../components/login/index'
import { PopupWarp } from '../../components/popup'
import { USER_INFO, LOGIN_CODE, SEND_CODE, USER_CAPTCHA } from '../../apis/user'
import { QR_CODE, ZH_CODE } from '../../apis/cabinet'
import { PAYMODE, STRIPE_PREAUTH_OF_CONFIRM, STRIPE_PREPAY_SPTOKEN, COUPON_SEND, STRIPE_PREAUTH_AUTO_CONFIRM, PAYPAL_PREAUTH, BALANCE_TO_RENT } from '../../apis/payment'
export default {
  mixins: [stripeMixin],
  components: {
    SelectArea,
    PreAuthorTip,
    RentCostTip,
    LoginCode,
    LoginGoogle,
    // LoginFacebook,
    // LoginApple,
    PopupWarp
  },
  watch: {
    'payMode.pPaymentType': {
      handler(val, oldVal) {
        console.log('payMode', val)
        if (val === 'APPLE_PAY' || val === 'STRIPE_APPLE' || val === 'STRIPE_GOOGLE' || val === 'GOOGLE_PAY') {
          if (!this.stripePayRequest && this.cabinet) {
            this.$loading(true)
            this.getStripeToken()
          }
        }
      },
      immediate: true, // 立即执行
      deep: true // 深度监听复杂类型内变化
    },
    cabinet(val) {
      if (val) {
        console.log('设备信息', val)
        this.getPayMode()
      }
    }
  },
  computed: {
    ...mapState([
      'browser',
      'user',
      'token',
      'cabinet',
      'system',
      'qrcode',
      'agentId',
      'loginMode',
      'inviteCode'
    ]),
    ...mapGetters(['locale']),
    scanUrl() {
      if (this.qrcode || this.$route.query.qrcode) {
        return `${QR_CODE}?id=${this.qrcode || this.$route.query.qrcode}`
      }
      if (this.zhcode || this.$route.query.zhcode) {
        return `${ZH_CODE}/${this.zhcode}`
      }
      return ''
    },
    i18n() {
      return this.$t('loginborrow')
    },
    i18nMsg() {
      return this.$t('msg')
    },
    i18nMine() {
      return this.$t('mine')
    },
    i18nConfirm() {
      return this.$t('confirm')
    },
    currency() {
      return (this.cabinet && this.cabinet.currency) || (this.user && this.user.pcurrency) || 'EUR'
    },
    currencyName() {
      return (this.cabinet && this.cabinet.currencyName) || (this.user && this.user.pcurrencyName) || '€'
    },
    placeholder() {
      return (this.cabinet && this.cabinet.yajin) ? `Pre-authorisation ${this.currency}${this.cabinet && this.cabinet.yajin}` : 'Pre-authorisation '
    }
  },
  data() {
    return {
      isAreaView: false,
      areaCode: '49',
      captchaUrl: '',
      code: '',
      uuid: '',
      phone: '',
      cardNum: '',
      couponCode: '',
      preAuthorShow: false,
      loginOptionShow: false,
      rentCostShow: false,
      loginCodeShow: false,
      isCreditcard: false,
      currentLoginMode: 'phone',
      payModeList: [],
      payMode: {
        pPaymentType: 'STRIPE_CARD'
      },
      cardStyle: {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      },
      stripePayRequest: null,
      creditcard: null,
      clientSecret: null,
      creditOrder: null
    }
  },
  methods: {
    // 支付方式选中
    onPayMode(v) {
      console.log('支付方式===', v)
      this.payMode = v
    },
    showLangSelect() {
      this.$store.commit('isLangView', true)
    },
    goOrder() {
      this.$router.push('/order')
    },
    onSelct(val) {
      this.areaCode = val
    },
    showRentCostPop() {
      // if (this.cabinet && this.cabinet.yajin) {
      this.rentCostShow = true
      // } else {
      //   this.$toast(this.i18nMine.getcabinetConfig)
      // }
    },
    viewAgreen(url) {
      window.open(url)
    },
    onCaptcha() {
      this.code = ''
      this.uuid = generateUUID()
      this.captchaUrl = `${baseURL}${USER_CAPTCHA}?uuid=${this.uuid}`
    },
    onLogout() {
      console.log('退出==')
      this.$confirm({
        title: this.i18nMsg.title,
        content: this.i18nMsg.msg_logout,
        confirmText: this.i18nMsg.confirm,
        cancelText: this.i18nMsg.cancel
      }).then(() => {
        this.$store.commit('user', '')
        this.$store.commit('token', '')
        this.$store.commit('appleIdToken', '')
        // this.$store.commit('qrcode', '')
        this.payModeList = []
      })
    },
    onRent() {
      console.log(this.cabinet)
      if (this.user) {
        if (this.cabinet && this.cabinet.zujieNum && this.cabinet.zujieNum > 0) {
          this.$toast(this.i18nMsg.exceedorder)
          return
        }
        this.onPay()
        // this.getCouponCode()
      } else {
        this.$router.push('/login')
      }
    },
    onPay() {
      if (this.cabinet.myyue >= this.cabinet.yajin && this.cabinet.myyue >= this.cabinet.overtimeAmount) {
        this.onBorrow()
      } else if (this.payMode.pPaymentType === 'APPLE_PAY' || this.payMode.pPaymentType === 'STRIPE_APPLE' || this.payMode.pPaymentType === 'STRIPE_GOOGLE' || this.payMode.pPaymentType === 'GOOGLE_PAY') {
        this.stripePayRequest.show()
      } else if (this.payMode.pPaymentType === 'STRIPE_CARD') {
        this.onCreditcard(this.payMode.publicKey)
      } else if (this.payMode.pPaymentType === 'PAYPAL') {
        this.onPaypal()
      }
    },
    onScan() {
      let url = this.scanUrl
      this.inputCodeShow = false
      this.$loading(true)
      this.$post(
        url,
        {},
        resp => {
          this.$loading(false)
          this.$store.commit('cabinet', {
            qrcode: this.code,
            ...resp
          })
          if (resp.zujieNum && resp.zujieNum > 0) {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: `${this.i18n.msg_rentcount}`.format(resp),
              confirmText: this.i18nMsg.confirm,
              cancelText: this.i18nMsg.cancel
            }).then(() => {
              // this.$store.commit('qrcode', '')
            }).catch(() => {
              // this.$store.commit('qrcode', '')
            })
          }
        },
        error => {
          this.$loading(false)
          let errstr = ''
          if (error.includes('is offline') || error.includes('离线')) {
            errstr = this.$t('home.offline', { devicecode: this.qrcode })
          } else if (error.includes('Permission') || error.includes('权限')) {
            errstr = this.$t('home.permissionfail')
          } else if (error.includes('not bound') || error.includes('未绑定')) {
            errstr = this.$t('home.unbound', { devicecode: this.qrcode })
          } else if (error.includes('No battery') || error.includes('可用')) {
            errstr = this.$t('home.nobattery', { devicecode: this.qrcode })
          } else {
            errstr = error
          }
          this.$confirm({
            title: this.i18n.msg_fail_title,
            confirmText: this.i18nMsg.confirm,
            content: errstr,
            showCancel: false
          }).then(() => {
            this.$store.commit('qrcode', '')
          })
        }
      )
    },
    loadUser(isOnScan = false) {
      this.$get(
        USER_INFO,
        {},
        resp => {
          if (resp.user) {
            this.$store.commit('user', resp.user)
            this.loginOptionShow = false
            if (isOnScan && this.qrcode) {
              this.onScan()
            }
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user,
              showOk: false,
              cancelText: this.i18nMsg.cancel
            }).then(() => {
              this.loadUser()
            })
          }
        },
        error => {
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18nMsg.userinfo_fail,
            confirmText: this.i18nMsg.confirm,
            showCancel: false
          })
          console.log(error)
        }
      )
    },
    getStripeToken() {
      getToken(this.cabinet && this.cabinet.yajin, this.onStripe)
        .then(data => {
          console.log('stripe getToken', data)
          this.stripePayRequest = data
          this.$loading(false)
        })
        .catch(error => {
          this.stripePayRequest = null
          console.log('stripe getTokenerr', error)
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_support,
            showCancel: false,
            confirmText: this.i18n.msg_fail_confirm
          })
        })
    },
    // apple和Google支付时调用
    onStripe(token, ev) {
      let url = ''
      let datas = {}
      if (this.cabinet) {
        url = STRIPE_PREPAY_SPTOKEN
        datas = {
          qrcode: this.cabinet.qrcode,
          stripeToken: token, // stripe官方支付的一次性token
          paymentId: this.payMode.pId // 代理或平台支付配置id
        }
      } else {
        this.$confirm({
          title: this.i18nMsg.title,
          content: this.i18nMsg.error,
          confirmText: this.i18nMsg.confirm,
          showCancel: false
        }).then(() => {
          this.$router.push('/')
        })
      }
      this.$post(
        url,
        datas,
        resp => {
          if (ev && ev.complete) {
            ev.complete('success')
          }
          this.$loading(false)
          console.log(resp)
          if (this.payType === 'CZ') {
            this.$confirm({
              title: this.i18nMsg.title,
              content: this.i18nMsg.success_payment,
              confirmText: this.i18nMsg.confirm,
              showCancel: false
            }).then(() => {
              this.$router.replace('/mine')
            })
          } else {
            this.$toast(this.i18nMsg.success_payment)
            if (this.payType === 'FK') {
              this.$router.replace(`/result?tradeNo=${resp.data.orderId}&payMode=stripe&payType=FK`)
              return
            }
            this.$router.replace(`/result?tradeNo=${resp.data.orderId}&payMode=stripe`)
          }
        },
        error => {
          if (ev && ev.complete) {
            ev.complete('fail')
          }
          this.$loading(false)
          console.log(error)
          this.$confirm({
            title: this.i18nMsg.title,
            content: error,
            confirmText: this.i18nMsg.confirm,
            showCancel: false
          })
        }
      )
    },
    onCreditcard(publicKey) {
      let url = ''
      let datas = {}
      url = `${STRIPE_PREAUTH_OF_CONFIRM}/${this.cabinet.qrcode}`
      datas = {
        paymentId: this.payMode.pId,
        amount: this.cabinet.yajin
      }

      this.$loading(true)
      this.$post(
        url,
        datas,
        resp => {
          this.$loading(false)
          console.log(resp)
          if (resp.data) {
            if (window.stripe) {
              this.clientSecret = resp.data
              const layout = {
                layout: {
                  type: 'tabs'
                }
              };
              const options = {
                clientSecret: resp.data.clientSecret,
                appearance: {
                  theme: 'stripe'
                }
              }
              this.creditcard = window.stripe.elements(options);
              const paymentElement = this.creditcard.create('payment', layout);
              this.isCreditcard = true
              paymentElement.mount('#credit-card-element');
            } else {
              this.$toast('loading...')
            }
          }
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.onCreditcard(publicKey)
          })
          console.log(error)
        }
      )
    },
    getCouponCode() {
      if (!this.cabinet) {
        return
      }
      this.$loading(true)
      this.$get(
        `${COUPON_SEND}?code=${this.couponCode}`,
        {},
        resp => {
          this.$loading(false)
          console.log(resp)
          this.onPay()
        },
        error => {
          this.$loading(false)
          console.log(error)
          this.onPay()
        }
      )
    },
    getPayMode() {
      this.$loading(true)
      this.$get(
        `${PAYMODE}?id=${this.cabinet.cabinetID}`,
        {},
        resp => {
          this.$loading(false)
          if (resp.data) {
            let list = resp.data
            list.map((v, i, arr) => {
              if (v.pPaymentType === 'STRIPE_CARD') {
                v.label = 'Credit Card'
                v.phone = 'all'
                let google = JSON.parse(JSON.stringify(v))
                google.label = 'Google Pay'
                google.phone = 'android'
                list.push(google)
                let apple = JSON.parse(JSON.stringify(v))
                apple.label = 'Apple Pay'
                apple.phone = 'ios'
                list.push(apple)
              } else if (v.pPaymentType === 'PAYPAL') {
                v.label = 'Paypal'
                v.phone = 'all'
              }
            })
            this.payModeList.push(...list)
            if (list.length > 0) {
              this.payMode = list[0]
              this.loadStripeScript(list[0].publicKey)
            }
          }
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_paymod,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.getPayMode()
          })
          console.log(error)
        }
      )
    },
    onLoadElement() {
      if (window.stripeElements) {
        // this.loadStripeScript(this.payMode.publicKey)
        this.creditcard = window.stripeElements.create('card', { style: this.cardStyle })
        this.creditcard.mount('#credit-card-element')
        this.$nextTick(() => {
          this.isCreditcard = true
        })
      } else {
        this.$toast('loading...')
        this.loadStripeScript()
        setTimeout(() => {
          this.onLoadElement()
        }, 500)
      }
    },
    onStripeSetup() {
      const vm = this
      vm.$loading(true)
      window.stripe
        .confirmPayment({
          elements: vm.creditcard,
          confirmParams: {
            return_url: window.location.href
          }
        })
      // paymentIntent通过付款方式确认卡设置
    },
    confirmSetup(id) {
      this.$loading(true)
      this.$get(
        `${STRIPE_PREAUTH_AUTO_CONFIRM}?tradeNo=${id}`,
        {},
        resp => {
          this.$loading(false)
          this.isCreditcard = false
          this.$router.replace(`/result?tradeNo=${resp.data.orderId}&payMode=stripe`)
          console.log(resp)
        },
        error => {
          this.$loading(false)
          console.log(error)
        }
      )
    },
    onLogin(code) {
      this.$loading(true)
      this.$post(
        LOGIN_CODE,
        {
          mobile: this.areaCode + this.phone,
          verifyCode: code,
          inviteCode: this.inviteCode
        },
        res => {
          console.log(res)
          this.$loading(false)
          if (res.token) {
            this.$store.commit('token', res.token)
            this.onCode()
            this.loginCodeShow = false
            this.loginOptionShow = false
            this.$store.commit('loginMode', 'phone')
          } else {
            this.$toast(this.i18n.msg_fail_login)
          }
        },
        err => {
          console.log(err)
          this.$loading(false)
        }
      )
    },
    onSendCode() {
      if (!this.phone) {
        this.$toast(this.i18nMsg.msg_fail_phone)
        return
      }
      // if (!this.code) {
      //   this.$toast(this.i18nMsg.msg_fail_code)
      //   return
      // }
      let timp = new Date().valueOf()
      let str = timp.toString().replace(/0/g, '8')
      let mdsign = md5((str + 'GZzbjkj'))
      // console.log(timp, str, mdsign, this.phone)
      this.$loading(true)
      this.$post(
        SEND_CODE,
        {
          mobile: this.areaCode + this.phone,
          timestamp: timp,
          sign: mdsign,
          useDebug: false
        },
        res => {
          console.log(res)
          this.$loading(false)
          this.loginCodeShow = true
          // this.onLogin('1234')
        },
        err => {
          console.log(err)
          this.$loading(false)
          this.$toast(err)
        }
      )
    },
    onPaypal() {
      this.$loading(true)
      let url = PAYPAL_PREAUTH
      this.$post(
        url + `/${this.cabinet.qrcode}`,
        {
          paymentId: this.payMode.pId
        },
        resp => {
          this.$loading(false)
          this.$store.commit('paypalTradeNo', resp.data.tradeNo)
          this.$store.commit('paymentId', this.payMode.pId)
          console.log(resp.data)
          window.location.href = resp.data.approve
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: this.i18n.msg_fail_order,
            confirmText: this.i18n.msg_fail_retry,
            cancelText: this.i18n.msg_fail_cancel
          }).then(() => {
            this.onPaypal()
          })
          console.log(error)
        }
      )
    },
    onCode() {
      console.log(this.qrcode)
      if (this.token) {
        this.loadUser()
      }
      if ((this.qrcode || this.$route.query.qrcode) && this.token) {
        this.onScan()
      }
    },
    onBorrow() {
      this.$loading(true)
      this.$get(
        `${BALANCE_TO_RENT}?qrcode=${this.cabinet.qrcode}`,
        {},
        (resp) => {
          this.$loading(false)
          console.log(resp)
          if (resp.data.outTradeNo) {
            this.$router.push(`/result?tradeNo=${resp.data.outTradeNo}`)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_content,
              confirmText: this.i18n.msg_fail_retry,
              showCancel: false
            })
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    }
  },
  created() {
    let qrCode = this.qrcode || this.$route.query.qrcode
    console.log('qrCode====', qrCode)
    if (qrCode) {
      this.$store.commit('qrcode', qrCode)
      if (this.user) {
        this.onCode()
      }
    }
    const payId = new URLSearchParams(window.location.search).get(
      'payment_intent'
    );
    if (payId) {
      this.confirmSetup(payId)
    }
    // this.onCode()
    // this.onCaptcha()
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
.buttonDiv /deep/ .S9gUrf-YoZ4jf {
  iframe {
    width: 100% !important;
    margin: 0 auto !important;
  }
}

.buttonDiv {
  position: relative;
  z-index: 99;
  top: 0;
  opacity: 0;
  height: 0 !important;
}

.googlewarp {
  position: absolute;
  top: 0;
  z-index: 90;
  width: 100%;
  border: solid 5px #dadce0;
  color: #3c4043;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  padding: 20px 0;

  img {
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }
}

.select {
  color: #000 !important;
  background-color: #E0E722 !important;
  border: none !important;
}

.selectd {
  color: #000;
  border: solid 1px #E0E722 !important;
}

.mb-8 {
  margin-bottom: 60px;
}

.minheight-5 {
  min-height: 90px;
}

.agreen {
  width: 80%;
  color: #6e6e6e;
  text-align: center;
  margin: 40px auto 20px;
  font-size: small;

  a {
    text-decoration: none;
    color: #202122;
    font-weight: 600;
  }
}

.loginbtn {
  border: solid 1px #EBEBEB;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  width: 100%;
  background: none;

  img {
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }
}

.addcard {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-radius: 20px;
  border: solid 1px #EBEBEB;
  color: #757575;

  // box-shadow: 3px 6px 10px #e8e8e8;
  .left {
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      margin-right: 20px;
    }
  }

  .right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  img {
    width: 40px;
    height: 40px;
  }
}

.home-body {
  background-color: #fff;
  border-top-left-radius: 100px;
  border-top-right-radius: 100px;
  overflow: hidden;
  padding: 40px;
  box-sizing: border-box;
  height: 100%;
  min-height: calc(100vh - 202px);
  .title {
    font-family: 'Montserrat-SemiBold';
    // text-align: center;
    font-size: 36px;
    font-weight: bold;
    // white-space: nowrap;
    text-align: center;
    margin: 0 0 50px;
  }

  .options {
    width: 47%;
    margin: 10px auto 0;
    font-family: 'Montserrat-Medium';
    text-align: center;
    color: #C8C8C8;
    border-radius: 20px;
    padding: 20px 0;
    background: none;
  }

  .logoutoptions {
    width: 100%;
    font-family: 'Montserrat-Medium';
    text-align: center;
    color: #C8C8C8;
    margin: 40px 0;
    background: none;
  }

  .normaltitle {
    font-family: 'Montserrat-Medium';
    font-size: 28px;
    color: #171917;
    margin: 30px 0 32px;
  }

  .paymethod {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .paymethod-item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 45px;
    border: solid 1px #EBEBEB;
    border-radius: 20px;
    margin-right: 30px;
    margin-bottom: 20px;
    img {
      width: 45px;
      height: 40px;
      margin-right: 10px;
    }

    span {
      // color: #000;
      font-size: 28px;
    }
  }

  .placeinput {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: solid 1px #EBEBEB;
    border-radius: 20px;
    padding: 20px;
    margin: 40px 0 0;

    .preicon {
      width: 38px;
      height: 38px;
      margin-right: 20px;
    }

    .afticon {
      width: 34px;
      height: 34px;
      margin-left: 20px;
    }

    .cvc {
      font-size: 28px;
      color: #C8C8C8;
    }

    input {
      flex: 1;
      border: none;
      outline: none;
      margin: 0;
      padding: 0;
    }
  }

  .shopdetail {
    border: dashed 4px #000;
    border-radius: 20px;
    padding: 10px;
    margin: 50px 0 30px;
    display: flex;
    align-items: center;
    position: relative;
    height: 100px;
    &>img {
      width: 78px;
      height: 142px;
      position: absolute;
      left: 20px;
      top: -30px;
    }

    .centermsg {
      padding-left: 120px;
      p {
        margin: 10px 0;
      }

      .top {
        font-size: 24px;
        color: #171917;
      }

      .bottom {
        color: #666666;
        font-size: 22px;
      }
    }

    .pricing {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-left: 40px;
      color: #000;

      img {
        width: 40px;
        height: 40px;
        margin-left: 10px;
      }
    }
  }

  .rentbtn {
    width: 100%;
    background: #E0E722;
    border-radius: 20px;
    color: #000;
    text-align: center;
    padding: 20px 0;
    font-family: 'Montserrat-SemiBold';
    font-size: 36px;
    font-weight: 500;
    max-height: 108px;
    margin: 40px 0 0;
  }

  .mt-4 {
    margin-top: 40px;
  }
}

.facebookbtn {
  border: solid 5px #dadce0;
  color: #3c4043;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  padding: 20px 0;
  margin-bottom: 40px;
  font-size: 28px;

  img {
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(53, 53, 53, 0.5);
  z-index: 100;

  .mask-main {
    position: absolute;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    border-top-right-radius: 100px;
    border-top-left-radius: 100px;
    padding: 40px;
  }

  .appleline {
    background-color: #EBEBEB;
    width: 30%;
    height: 8px;
    border-radius: 100px;
    margin: 0 auto 40px;
  }

  .loginoptions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    margin: 60px 0;

    &-item {
      border: solid 1px #EBEBEB;
      border-radius: 20px;
      color: #666666;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px 20px;
      margin: 10px 25px 0 0;

      img {
        width: 30px;
        height: 40px;
        margin-right: 10px;
      }
    }
  }

  .phonelogin {
    border: solid 1px #EBEBEB;
    border-radius: 20px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    margin-bottom: 40px;

    img {
      width: 60px;
      height: 60px;
      border-radius: 100%;
      transform: rotateZ(180deg);
    }

    input {
      flex: 1;
      font-size: smaller;
      border: none;
      outline: none;
    }

    .captcha {
      width: 180px;
    }

    .area {
      width: 100px;
      padding: 0 10px;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }

    .area-down {
      // margin-left: 10px;
      width: 0;
      height: 0;
      border-width: 10px 10px 0;
      border-style: solid;
      border-color: black transparent transparent;
    }
  }

  .facebookbtn {
    border: solid 5px #dadce0;
    color: #3c4043;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    padding: 20px 0;
    margin-bottom: 40px;
    font-size: 28px;

    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }

  .goolebtn {
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    border: solid 1px #EBEBEB;
    color: #000;
    width: 100%;
    padding: 20px 0;
    margin-bottom: 40px;
    font-size: 28px;

    img {
      width: 60px;
      height: 60px;
      margin-right: 10px;
    }
  }
}

.creditcard-input {
  margin: 48px 48px 48px;
  padding: 20px;
  border-radius: 20px;
  border: 1Px solid #E4E7ED;
}

.creditcard-btn {
  margin: 48px;
}

.addsign {
  float: left;
  background-color: #fff;
  box-shadow: 3px 6px 10px #e8e8e8;
  padding: 10px;
  width: 18%;
  height: 100%;
  border-radius: 20px;
  margin: 33px 0 20px 20px;

  span {
    display: block;
    background-color: #dddddd;
    color: #fff;
    font-size: 85px;
    text-align: center;
    border-radius: 20px;
  }
}

.scroll-x {
  float: right;
  width: 70%;
  overflow-x: scroll;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 20px;
}

.popup-card-list {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 3px 6px 10px #e8e8e8;
  padding: 10px 20px;
  margin: 20px 20px 20px 0;

  p {
    margin: 0;
  }

  .value {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    color: #00904A;
    font-weight: 500;

    .pBrand {
      font-size: 40px;
      margin-bottom: 10px;
    }
  }

  .deleteicon {
    width: 60px;
    height: 60px;
    position: absolute;
    top: -20px;
    right: -20px;
  }
}
</style>
